import React from "react";
import { Header } from "../components/Header";
import { Link } from "react-router-dom";
import { ScrollTrigger } from "../components/ScrollTrigger";
import { CtaList } from "../components/CtaList";
import { Footer } from "../components/Footer";
import "../assets/styles/lp.scss";

type ButtonProps = {
  children: React.ReactElement;
  href: string;
  margin?: string;
};

const Button = (props: ButtonProps) => {
  return (
    <Link
      to={props.href}
      className="btn"
      style={{
        margin: props.margin,
      }}
    >
      {props.children}
    </Link>
  );
};

export const Lp = () => {
  const isSp = window.innerWidth < 750;
  const stepClassName = isSp ? "undefined" : "slideIn";

  return (
    <div className="lp">
      <Header>
        <div className="header-contents">
          <img
            src="../images/lp/header-img.png"
            alt="大切な資産を共に活かす"
            className="header-img"
          />
          <img
            src="../images/lp/header-img_sp.png"
            alt="大切な資産を共に活かす"
            className="header-img_sp sp"
          />

          <div className="inner">
            <ul className="panel-list">
              <li>
                <h3>
                  <span>創業初年度の相談実績</span>
                  <br />
                  <strong>500</strong>
                  <span className="red">件以上！</span>
                </h3>
              </li>
              <li>
                <h3>
                  <span>相談料</span>
                  <br />
                  <strong>無料!</strong>
                </h3>
              </li>
              <li>
                <h3>
                  <span>対面・オンライン</span>
                  <br />
                  <span className="red">どちらでも</span>
                  <strong>OK</strong>
                </h3>
              </li>
              <li>
                <h3>
                  <span>所要時間</span>
                  <br />
                  <strong>30</strong>
                  <span className="red">分〜</span>
                </h3>
              </li>
            </ul>
            <h2>
              不動産のことなら、
              <br className="sp" />
              なんでもご相談ください！
            </h2>
            <Button href="/contact">
              <div>
                <p>
                  ＼<strong>3</strong>
                  <span className="red">分</span>
                  でカンタン申込み！／
                </p>
                <h4>
                  無料相談の
                  <br className="sp" />
                  お申込みはこちら
                </h4>
              </div>
            </Button>
            <img src="../images/lp/women.png" alt="" className="women" />
          </div>
        </div>
      </Header>
      <section className="worry">
        <div className="worry-top">
          <div className="inner">
            <ScrollTrigger
              className="fadeInUp"
              animationClassName="fadeInUp-active"
            >
              <h2>
                <p>不動産について</p>
                <br />
                <strong>
                  こんな<span className="red">お悩み</span>ありませんか？
                </strong>
              </h2>
            </ScrollTrigger>
            <ul className="worry-list">
              <li>
                <p>
                  <span className="red">
                    相続税・
                    <br className="sp" />
                    不動譲渡税
                  </span>
                  を<br className="sp" />
                  抑えたい
                </p>
              </li>
              <li>
                <p>
                  <span className="red">
                    所有物件を
                    <br className="sp" />
                    売却したい
                  </span>
                  が<br />
                  相場が全くわからない
                </p>
              </li>
              <li>
                <p>
                  <span className="red">
                    不動産投資を
                    <br className="sp" />
                    始めたい
                  </span>
                  けど
                  <br />
                  まず何をすれば
                  <br className="sp" />
                  いいのかわからない
                </p>
              </li>
              <li>
                <p>
                  <span className="red">自宅を売却したい</span>
                  が、
                  <br />
                  スムーズな
                  <br className="sp" />
                  住み替え方法が
                  <br className="sp" />
                  わからない
                </p>
              </li>
              <li>
                <p>
                  <span className="red">相続をしたが</span>
                  <br className="sp" />
                  活用方法が
                  <br className="sp" />
                  わからない
                </p>
              </li>
              <li>
                <p>
                  他社に依頼
                  <br className="sp" />
                  しているが
                  <br className="sp" />
                  <span className="red">
                    買い手が
                    <br className="sp" />
                    見つからない
                  </span>
                </p>
              </li>
              <li>
                <p>
                  3日で<span className="red">現金化したい</span>
                </p>
              </li>
              <li>
                <p>
                  <span className="red">誰にも知られず</span>
                  <br className="sp" />
                  売却したい
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="worry-bottom">
          <div className="inner">
            <ScrollTrigger
              className="fadeInUp"
              animationClassName="fadeInUp-active"
            >
              <h2>
                その悩み、ドリミットの
                <br />
                <span>コンサルタントが解決します！</span>
              </h2>
            </ScrollTrigger>
            <div className="step-box">
              <img src="../images/lp/women2.png" alt="" className="women" />
              <h3>
                <p>
                  カンタン
                  <span className="red">
                    <strong>3</strong>
                    ステップ！
                  </span>
                </p>
                お申し込みからご相談までの流れ
              </h3>
              <ol>
                <ScrollTrigger
                  className={stepClassName}
                  animationClassName={stepClassName + "-active"}
                >
                  <li>
                    <img
                      src="../images/lp/step-1.png"
                      alt="申込み"
                      className="pc-arrow"
                    />
                    <img
                      src="../images/lp/step-1_sp.png"
                      alt="申込み"
                      className="sp"
                    />
                    <p>申し込みフォームは</p>
                    <Link to="/contact" className="entry">
                      こちら
                    </Link>
                  </li>
                </ScrollTrigger>
                <ScrollTrigger
                  className={stepClassName}
                  animationClassName={stepClassName + "-active"}
                  delay="0.2s"
                >
                  <li>
                    <img
                      src="../images/lp/step-2.png"
                      alt="面談日決定"
                      className="pc-arrow"
                    />
                    <img
                      src="../images/lp/step-2_sp.png"
                      alt="申込み"
                      className="sp"
                    />
                    <p>
                      ご予約の案内を
                      <br />
                      メールにてお送りします
                    </p>
                  </li>
                </ScrollTrigger>
                <ScrollTrigger
                  className={stepClassName}
                  animationClassName={stepClassName + "-active"}
                  delay="0.4s"
                >
                  <li>
                    <img
                      src="../images/lp/step-3.png"
                      alt="面談当日"
                      className="pc-arrow"
                    />
                    <img
                      src="../images/lp/step-3_sp.png"
                      alt="申込み"
                      className="sp"
                    />
                    <p>
                      オンラインご希望の場合は
                      <br />
                      Google MeetのURLを
                      <br />
                      メールにてお送りします
                    </p>
                  </li>
                </ScrollTrigger>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="about">
        <h3>
          <span>ドリミットがお客様と目指すのは</span>
          <br />
          <span>
            <ScrollTrigger
              className="blurIn"
              animationClassName="blurIn-active"
            >
              <strong id="bigTitle">｢資産の最大化｣</strong>
            </ScrollTrigger>
            です
          </span>
          <br />
        </h3>
        <h2>
          <p>
            <strong>資産の最大化</strong>
            <span>MAXIMIZE ASSETS</span>
          </p>
          <ScrollTrigger animationClassName="fadeIn-active" className="fadeIn">
            <img src="../images/top-about.png" alt="資産の最大化" />
          </ScrollTrigger>
        </h2>
        <div className="about-contents">
          <div className="inner">
            <ul>
              <li>相続対策</li>
              <li>賃貸経営</li>
              <li>競売/任意売却サポート</li>
              <li>節税対策</li>
              <li>老後資金対策</li>
              <li>負債整理</li>
              <li>最適な管理方法</li>
              <li>資産の買い替え/入れ替え</li>
            </ul>
            <ScrollTrigger
              animationClassName="fadeIn-active"
              className="fadeIn"
            >
              <img src="../images/top-about_sp.png" alt="資産の最大化" />
            </ScrollTrigger>
            <p className="normal-text top">
              お客様の状況をヒアリングし、
              <br className="sp" />
              様々な角度から「資産の最大化」を目指し
              <br className="sp" />
              コンサルティングを行います。
            </p>
            <p className="normal-text">
              弊社コンサルタントの
              <br className="sp" />
              <strong>全員が資格保持者！</strong>
              <br />
              一人一人に最適な方法をオーダーメイドで
              <br className="sp" />
              ご提案いたします。
            </p>
            <Button href="/contact">
              <div>
                <p>
                  ＼<strong>3</strong>
                  <span className="red">分</span>
                  でカンタン申込み！／
                </p>
                <h4>
                  無料相談の
                  <br className="sp" />
                  お申込みはこちら
                </h4>
              </div>
            </Button>
          </div>
        </div>
      </section>
      <section className="voice">
        <div className="inner">
          <h2>
            <p>USER’S VOICE</p>
            実際にあったご相談内容
          </h2>
          <ol className="voice-list">
            <li>
              <div className="contents">
                <p className="tag">VOICE 01</p>
                <h5>
                  他社で売却を検討中、
                  <br className="sp" />
                  思うような金額が出ずに困っていた。
                </h5>
                <p className="text">
                  親族から相続した大切な物件を他社で安く評価され、売却自体を諦めかけた時に不動産や税金に関する知識があり、経験豊富な担当コンサルタントさんと出会いました。
                  <br />
                  <br />
                  私たち相続人の気持ちを十分理解していただいただけでなく、納得のできる金額で売却をすることができました。また売却後の税金についても丁寧にご教示いただき本当に任せてよかったです。
                </p>
              </div>
              <div className="user">
                <img src="../images/lp/voice-1.png" alt="" className="thumb" />
                <p className="name">
                  東京都 Nさん
                  <br />
                  58歳
                </p>
              </div>
            </li>
            <li>
              <div className="contents">
                <p className="tag">VOICE 02</p>
                <h5>
                  他社から提案のあった
                  <br className="sp" />
                  資産形成について疑問を感じていた。
                </h5>
                <p className="text">
                  定年を見据え、老後資金の工面に苦悩していた際、複数社へご提案をお願いしました。
                  <br />
                  <br />
                  その際、どこの会社も本質的な運用戦略が見えずにいましたが、ドリミット株式会社様と出会い、他社では提案のなかった税務知識及び本質的な運用戦略に加え、本来の不動産価値を算出する方法をご提案いただき、私自身と家族が一切の懸念を持たずに邁進することができております。
                </p>
              </div>
              <div className="user">
                <img src="../images/lp/voice-2.png" alt="" className="thumb" />
                <p className="name">
                  千葉県 Aさん
                  <br />
                  60歳
                </p>
              </div>
            </li>
            <li>
              <div className="contents">
                <p className="tag">VOICE 03</p>
                <h5>
                  大手不動産会社と
                  <br className="sp" />
                  媒介契約を結んでいたが売れずに困っていた。
                </h5>
                <p className="text">
                  大手という信用力へ期待し、早期売却を望んでおりましたが、日々の内見は一定数あるものの中々売れず、毎月のランニングコストが負担となり悩んでおりました。
                  <br />
                  <br />
                  やはりランニングコスト自体、当たり前ですが物件所有者が負担するものなので、負担の重さを大手の担当者では理解いただけず、初めての売却活動だったためそんなものなのかと思っておりましたが貴社の担当コンサルタント様と出会い、親身に寄り添っていただいただけでなく、大手では3か月売れなかった物件が早急に契約から決済まで完結し、驚いたとともに凄く安心しました。
                </p>
              </div>
              <div className="user">
                <img src="../images/lp/voice-3.png" alt="" className="thumb" />
                <p className="name">
                  埼玉県 Hさん
                  <br />
                  65歳
                </p>
              </div>
            </li>
            <li>
              <div className="contents">
                <p className="tag">VOICE 04</p>
                <h5>
                  賃貸経営の収益率が
                  <br className="sp" />
                  悪く悩んでいた。
                </h5>
                <p className="text">
                  数年ほど前に物件を取得し資産形成を始めました。しかしながら、物件取得当初に予定していたシミュレーション通りにいかず、改善点が分からないまま、やはり素人が手を出してはいけない領域ではないのかと思っておりましたが、担当コンサルタントさんに出会い、支出を抑え収入を最大化する方法から安定的な資産運用方法をご教示いただき軌道に乗ることが出来ました。
                  <br />
                  <br />
                  現在は、担当コンサルタントさんと相談を行いながら資産の入れ替えを行っており今後の将来へ向けた資産運用が楽しみです。
                </p>
              </div>
              <div className="user">
                <img src="../images/lp/voice-4.png" alt="" className="thumb" />
                <p className="name">
                  埼玉県 Kさん
                  <br />
                  48歳
                </p>
              </div>
            </li>
          </ol>
          <div className="step-box">
            <h3>
              <p>
                カンタン
                <span className="red">
                  <strong>3</strong>
                  ステップ！
                </span>
              </p>
              お申し込みからご相談までの流れ
            </h3>
            <ul>
              <ScrollTrigger
                className={stepClassName}
                animationClassName={stepClassName + "-active"}
              >
                <li>
                  <img
                    src="../images/lp/step-1.png"
                    alt="面談当日"
                    className="pc-arrow"
                  />
                  <img
                    src="../images/lp/step-1_sp_2.png"
                    alt="申込み"
                    className="sp"
                  />
                </li>
              </ScrollTrigger>
              <ScrollTrigger
                className={stepClassName}
                animationClassName={stepClassName + "-active"}
                delay="0.2s"
              >
                <li>
                  <img
                    src="../images/lp/step-2.png"
                    alt="面談当日"
                    className="pc-arrow"
                  />
                  <img
                    src="../images/lp/step-2_sp_2.png"
                    alt="申込み"
                    className="sp"
                  />
                </li>
              </ScrollTrigger>
              <ScrollTrigger
                className={stepClassName}
                animationClassName={stepClassName + "-active"}
                delay="0.4s"
              >
                <li>
                  <img
                    src="../images/lp/step-3.png"
                    alt="面談当日"
                    className="pc-arrow"
                  />
                  <img
                    src="../images/lp/step-3_sp_2.png"
                    alt="申込み"
                    className="sp"
                  />
                </li>
              </ScrollTrigger>
            </ul>
          </div>
          <Button href="/contact">
            <div>
              <p>＼まずは無料でご相談／</p>
              <h4>お申込みはこちら</h4>
            </div>
          </Button>

          <CtaList />
        </div>
      </section>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
